import React from 'react';

import {
  useEditInvestorCardModalLazyQuery,
  useSaveInvestorCardMutation
} from 'generated/graphql';
import _ from 'lodash';
import {
  formUtil,
  useLoading,
  validationUtil
} from 'modules';
import * as yup from 'yup';



const __formSchema = yup.object({
  companyName: validationUtil.nonEmptyStringSchema.required('Company name is required.'),
  potentialInvestmentAmount: yup.lazy(value =>
    value === '' ? yup.string() : yup.number().positive())
}).required();


export type IFormData = yup.InferType<typeof __formSchema>;



export function useEditInvestorCardModal(campaignId?: string, investorCardId?: string) {
  const [fnRunQuery, tuple] = useEditInvestorCardModalLazyQuery({});
  const [saveInvestorCard, saveInvestorCardTuple] = __useSaveInvestorCard(campaignId, investorCardId);
  const loading = useLoading([tuple, saveInvestorCardTuple]);



  React.useEffect(() => {
    if (investorCardId) {
      fnRunQuery({ variables: { investorCardId } });
    }
  }, [fnRunQuery, investorCardId]);



  const form = formUtil.useRemoteData2FormState_experimental({
    schema: __formSchema,
    tuple: tuple as any,
    fnGqlData2FormState: (data: any) => ({
      companyName: data?.investorCard?.displayName ?? '',
      potentialInvestmentAmount: data?.investorCard?.potentialInvestmentAmountDollars ?? 0
    })
  });

  return {
    form,
    loading,
    mutations: { saveInvestorCard }
  };
}



function __useSaveInvestorCard(campaignId?: string, id?: string) {
  const [fnMutate, tuple] = useSaveInvestorCardMutation({});

  async function fnWrappedMutate(formData: IFormData) {
    fnMutate({
      variables: {
        input: {
          id,
          displayName: formData.companyName,
          campaignId: id ? undefined : campaignId,
          potentialInvestmentAmountDollars: formData.potentialInvestmentAmount && !_.isString(formData.potentialInvestmentAmount) ? formData.potentialInvestmentAmount : 0
        }
      }
    });
  }


  return [fnWrappedMutate, tuple] as const;
}
